export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy, upload } from "utils/fetchRequest";

export const uploadImage = async (data) => {
  try {
    const result = await upload("files/comment", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getCommentList = async (searchText) => {
  try {
    const result = await get(
      `comment${searchText ? `?search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getCommentContent = async (newsId) => {
  try {
    const result = await get(`comment/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createComment = async (data) => {
  try {
    const result = await post("comment", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateComment = async (id, data) => {
  try {
    const result = await put(`comment/${id}`, data);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteComment = async (id) => {
  try {
    const result = await destroy(`comment/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setSpecial = async (id, data) => {
  try {
    const result = await put(`comment/special/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};
